export { default } from './CollectionCards';
